/**
 * App with Azure AD Authentication
 * Wraps the main App with AuthProvider and handles login flow
 */

import React from 'react';
import { AuthProvider, useAuth } from './components/AuthProvider';
import LoginPage from './components/LoginPage';
import AuthCallback from './components/AuthCallback';
import App from './App';

/**
 * Loading spinner component
 */
function LoadingScreen() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #1e3a5f 0%, #0d1b2a 100%)',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '48px',
        textAlign: 'center',
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '4px solid #e2e8f0',
          borderTopColor: '#3b82f6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 24px',
        }}></div>
        <p style={{ color: '#1e3a5f', fontSize: '18px', fontWeight: '500' }}>
          Loading...
        </p>
        <style>
          {`@keyframes spin { to { transform: rotate(360deg); } }`}
        </style>
      </div>
    </div>
  );
}

/**
 * Auth-aware router component
 */
function AuthRouter() {
  const { isAuthenticated, loading, user } = useAuth();
  const path = window.location.pathname;

  // Show loading while checking auth state
  if (loading) {
    return <LoadingScreen />;
  }

  // Handle auth callback route
  if (path === '/auth/callback') {
    return <AuthCallback />;
  }

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // User is authenticated - show main app
  return <App user={user} />;
}

/**
 * Main App with Auth wrapper
 */
function AppWithAuth() {
  return (
    <AuthProvider>
      <AuthRouter />
    </AuthProvider>
  );
}

export default AppWithAuth;
